<template>
    <div class="item w-full">
        <div class="m-4" v-if="item">
            <div class="mb-8">
                <span :class="(dark) ? 'text-medredDark' : 'text-sideLight'" v-html="item.img"></span>
            </div>
            <div class="mb-8">
                <h4 class="text-xl font-bold" :class="(dark) ? 'text-white' : 'text-black'">{{item.title}}</h4>
            </div>
            <p :class="(dark) ? 'text-widgetheaderLight' : 'text-par'">{{item.desc}}</p>
            <div class="p-4" v-if="item.stats">
                <ul class="list-disc" v-for="(data, i) in item.stats" :key="i">
                    <li class="text-base" :class="(dark) ? 'text-widgetheaderLight' : 'text-par'">{{data}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfosData',
    props: {
        item: {
            type: Object,
        },
        dark: {
            type: Boolean
        }
    },
}
</script>